<div class="flex flex-col max-w-240 md:min-w-160 max-h-screen -m-6 dms-modal " 
    >
    <div class="flex flex-0 items-center justify-between  bg-primary text-on-primary modal_header">
        <div class="col">
            <div class="modal_title">{{ 'Share' | lpmLabel:'shareModalTitle' }}</div>
            <div class="modal_title_desc">{{data.name}}</div>
        </div>
        <button mat-icon-button (click)="matDialogRef.close();" [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
    </div>
    <div class="flex flex-col flex-auto p-1 md:p-1">
    <mat-tab-group [selectedIndex]="selectedTab" class="asset-tab-group" [class.hide-tab-header]="hideTabHeader" (selectedTabChange)="onTabChanged($event);"

    >
        <!-- Tab - Info -->
        <mat-tab *ngIf="isInternalShareSupported" label="Internal sharing" class="tab-item-internal">
            <div class="mb-6">
                <!-- Instructions -->
                <div class="instruction-alert flex items-start gap-2 p-3 rounded-lg border">
                    <mat-icon
                        class="icon-size-5 mt-0.5 modal_instruction_icon"
                        svgIcon="dms-custom:info-circle">
                    </mat-icon>
                    <div class="flex flex-col">
                        <span class="title">
                            Instructions
                        </span>
                        <span class="description">
                            Select users and manage access levels
                        </span>
                    </div>
                </div>
            </div>
            <form class="flex flex-col flex-auto pb-3">
                <div class="grid sm:grid-cols-10 w-full">
                    <div class="sm:col-span-10 mb-6">
                        <div class="flex items-end gap-2">
                            <div class="flex-1 min-w-0">
                                <mat-label class="text-sm mb-1 block text-secondary">Select Users</mat-label>
                                <ng-select class="custom" typeToSearchText="Type to search" name="users" bindValue="id"
                                    [placeholder]="placeHolder" [multiple]="true" [loading]="showSpinner"
                                    [dropdownPosition]="'bottom'" [clearable]="(true)"
                                    [(ngModel)]="ngModelValue" (search)="onValueChanged($event)"
                                    (ngModelChange)="OnChange($event)">
                                    <ng-option *ngFor="let user of itemsList" [value]="user.id">{{user.email}}</ng-option>
                                </ng-select>
                            </div>
                            <div class="w-32 flex-none role-select" *ngIf="!isViewer">
                                <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
                                    <mat-select [(value)]="level.access" name="role" placeholder="Role" [(ngModel)]="level.access">
                                        <mat-option [value]="'VIEWER'">VIEWER</mat-option>
                                        <mat-option [value]="'WRITER'">WRITER</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="sm:col-span-10 mb-3">
                        <div class="text-medium">
                            Users with access
                            <span *ngIf="InternalAccessCount > 0" 
                                  class="ml-1 text-sm font-normal text-secondary">
                                ({{ InternalAccessCount }})
                            </span>
                            <span *ngIf="InternalAccessCount == 0"
                                  class="ml-1 text-sm font-normal text-hint">
                                — No users have access yet
                            </span>
                        </div>
                    </div>
                    <div class="sm:col-span-10 mb-6" *ngIf="peopleAccess && InternalAccessCount > 0 ">
                        <ngx-loading [show]="isLoading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>
                        <cdk-virtual-scroll-viewport 
                            #viewport 
                            [itemSize]="peopleAccess.length" 
                            class="user-access-viewport">
                        <div class="flex items-center row-hover py-2 px-2 gap-3 example-item" *ngFor="let item of peopleAccess; let i = index">
                            <!-- Avatar -->
                            <div class="flex flex-shrink-0 items-center justify-center w-9 h-9 rounded-full overflow-hidden bg-gray-100" *ngIf="!isExternal(item)">
                                <img *ngIf="item?.user?.profilePic" class="object-cover w-full h-full" [src]="item?.user?.profilePic" alt="Contact avatar" />
                                <mat-icon *ngIf="!item?.user?.profilePic" class="icon-size-5 text-gray-400" svgIcon="heroicons_outline:user"></mat-icon>
                            </div>
                            <!-- Name + Email -->
                            <div class="flex-1 min-w-0" *ngIf="!isExternal(item)">
                                <span class="block font-medium truncate">{{item?.user?.firstName}}&nbsp;{{item?.user?.lastName}}{{item.createdBy.id === item.user.id ? ' (You)' : ''}}</span>
                                <span class="text-sm block text-secondary truncate">{{item?.user?.email}}</span>
                            </div>
                            <!-- OWNER badge -->
                            <div class="flex-none" *ngIf="item.access =='OWNER'">
                                <span class="text-sm text-secondary font-medium pe-1">OWNER</span>
                            </div>
                            <!-- Role selector -->
                            <div class="flex-none" *ngIf="item.access !='OWNER' && !isExternal(item) && !isViewer">
                                <mat-form-field
                                    class="fuse-mat-dense w-40"
                                    [subscriptSizing]="'dynamic'">
                                    <mat-select
                                        [panelClass]="'perm-role-panel w-72 min-w-72 max-w-72 h-auto max-h-none'"
                                        name="role-{{i}}" placeholder="Role" [(ngModel)]="peopleAccess[i].access"
                                        (ngModelChange)="change(item,i)"
                                        disableOptionCentering
                                        #roleSelect="matSelect">
                                        <mat-select-trigger class="text-md">
                                            <span class="access_member_role">Role:</span>
                                            <span class="access_member_role">{{peopleAccess[i].access | titlecase}}</span>
                                        </mat-select-trigger>
                                        <ng-container *ngFor="let role of roles">
                                            <mat-option
                                                *ngIf="role.value!=='OWNER'"
                                                class="h-auto py-4 leading-none"
                                                [value]="role.value">
                                                <div class="font-medium">{{role.value}}</div>
                                                <div class="mt-1.5 text-sm whitespace-normal leading-normal text-secondary">{{role.description}}</div>
                                            </mat-option>
                                        </ng-container>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </cdk-virtual-scroll-viewport>
                    </div>
                    <div class="sm:col-span-8 mb-2" *ngIf="level.userIds && level.userIds.length>0">
                        <mat-checkbox [color]="'primary'" [(ngModel)]="level.notify" name="notify">
                            Notify
                        </mat-checkbox>
                    </div>
                    <div class="sm:col-span-10 mb-2" *ngIf="level.userIds.length>0">
                        <mat-form-field class="w-full">
                            <textarea matInput placeholder="Message" rows="3" [(ngModel)]="level.note" name="note"></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </form>
        </mat-tab>


        <mat-tab label="External sharing" class="tab-item-external" *ngIf="isWebComponent && isExternalShareSupported" >
        
            <div class="flex flex-col gap-6">
    
            <!-- Instructions -->
            <div class="instruction-alert flex items-start gap-2 p-3 rounded-lg border">
                <mat-icon
                    class="icon-size-5 mt-0.5 modal_instruction_icon"
                    svgIcon="dms-custom:info-circle">
                </mat-icon>
                <div class="flex flex-col">
                    <span class="title">
                        Instructions
                    </span>
                    <span class="description">
                        {{ 'Enter email and manage access level' | lpmLabel:'externalShareInstructions' }}
                    </span>
                </div>
            </div>
        
            <!-- Access Form -->
            <form class="flex flex-col flex-auto gap-6">
                 <!-- Access Section -->
                <div class="flex flex-col w-full gap-6">

                    <!-- Add Access Section -->
                    <div class="flex items-end gap-2 sm:col-span-10">
                        <!-- Row -->
                            <!-- search input -->
                            <div class="flex flex-1 min-w-0 flex-col gap-2">
                                <mat-label class="text-lg font-medium block select-label">{{ 'Select Users' | lpmLabel:'externalShareSelectLabel' }}</mat-label>
                                <ng-select class="custom block" typeToSearchText="Type to search" name="contact"
                                    placeholder="Search for contacts by name or email" [multiple]="true" [loading]="showSpinner"
                                    [dropdownPosition]="'bottom'" [clearable]="(true)"
                                    [(ngModel)]="ngModelExt" (search)="onValueExtChanged($event)"
                                    (add)="add($event)">
                                    <ng-option *ngFor="let contact of itemsListExt" [value]="contact">{{contact?.firstName}}&nbsp;{{contact?.lastName}}</ng-option>
                                </ng-select>
                            </div>
                            <!-- dropdown -->
                            <div class="w-32 flex-none role-select">
                                <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
                                    <mat-select [(value)]="level.access" name="role" placeholder="Role" [(ngModel)]="externalAccess">
                                        <mat-option [value]="'WRITER'">{{ 'WRITER' | lpmLabel:'externalShareWriterRoleLabel' }}</mat-option>
                                        <mat-option [value]="'VIEWER'">{{ 'VIEWER' | lpmLabel:'externalShareViewerRoleLabel' }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                    </div>

                    <!-- Contacts with access Section -->
                     <div class="flex flex-col gap-2">
                        <!-- Access Count -->
                        <div class="text-lg flex cont sm:col-span-10 w-full items-center">
                            <span class="text-lg font-medium"> Contacts with access </span>
                            <span *ngIf="ExternalAccessCount > 0"
                                  class="ml-1 text-sm font-normal text-secondary">
                                ({{ ExternalAccessCount }})
                            </span>
                            <span *ngIf="!peopleAccess || ExternalAccessCount === 0"
                                  class="ml-1 text-lg font-normal text-hint">
                                — No contacts have access yet
                            </span>
                        </div>
                        <!-- Access List -->
                        <div class="sm:col-span-10" *ngIf="ExternalAccessCount > 0 ">
                            <ngx-loading [show]="isLoading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>
                            <cdk-virtual-scroll-viewport 
                                #viewport 
                                [itemSize]="peopleAccess.length" 
                                class="user-access-viewport">
                                <ng-container *ngFor="let item of peopleAccess; let i = index">
                                    <div class="flex items-center row-hover py-2 px-2 gap-3 sm:col-span-10 example-item" *ngIf="isExternal(item)">
                                        <!-- Avatar -->
                                        <div class="flex flex-shrink-0 items-center justify-center w-9 h-9 rounded-full overflow-hidden bg-gray-100">
                                            <img *ngIf="item?.user?.profilePic" class="object-cover w-full h-full" [src]="item?.user?.profilePic" alt="Contact avatar" />
                                            <mat-icon *ngIf="!item?.user?.profilePic" class="icon-size-5 text-primary" svgIcon="heroicons_outline:user"></mat-icon>
                                        </div>
                                        <!-- Name + Email -->
                                        <div class="flex-1 min-w-0">
                                            <span class="block font-medium truncate">{{item?.user?.firstName}}&nbsp;{{item?.user?.lastName}}</span>
                                            <span class="text-sm block text-secondary truncate">{{item?.user?.email}}</span>
                                        </div>
                                        <!-- Role selector -->
                                        <div class="flex-none">
                                            <mat-form-field class="fuse-mat-dense w-40" [subscriptSizing]="'dynamic'">
                                                <mat-select name="role-{{i}}" placeholder="Role" [(ngModel)]="peopleAccess[i].access"
                                                    (ngModelChange)="changeExternal(item,i)">
                                                    <mat-select-trigger class="text-md">
                                                        <span class="access_member_role">Role:</span>
                                                        <span class="access_member_role">{{peopleAccess[i].access | titlecase}}</span>
                                                    </mat-select-trigger>
                                                    <mat-option [value]="'WRITER'">{{ 'WRITER' | lpmLabel:'externalShareWriterRoleLabel' }}</mat-option>
                                                    <mat-option [value]="'VIEWER'">{{ 'VIEWER' | lpmLabel:'externalShareViewerRoleLabel' }}</mat-option>
                                                    <mat-option [value]="'Remove access'">Remove Access</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </ng-container>

                        </cdk-virtual-scroll-viewport>
                        </div>
                    </div>

                    <!-- Other Options -->
                    <div class="sm:col-span-8" *ngIf="ngModelExt && ngModelExt.length>0">
                        <mat-checkbox [color]="'primary'" [(ngModel)]="extNotify" name="notifyExt">
                            Notify people
                        </mat-checkbox>
                    </div>
                    <div class="sm:col-span-10" *ngIf="peopleAccess.length>0 && extNotify">
                        <mat-form-field class="w-full">
                            <textarea matInput placeholder="Message" rows="3" [(ngModel)]="level.note" name="note"></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </form>
        </div>
        </mat-tab>
    </mat-tab-group>
</div>

    <!-- Actions/Footer -->
    <div class="share-actions flex sm:flex-row sm:items-center justify-end px-6 border-t border-gray-200" *ngIf="activeTab === 'internal'">
        <button class="share-cancel-btn border mr-2" [color]="'transparent'"
            mat-stroked-button
            (click)="cancel()">
            Cancel
        </button>
        <div class="flex items-center gap-2">
            <button
                class="share-submit-btn"
                mat-flat-button
                [color]="'primary'"
                [disabled]="isLoading || level.userIds.length == 0" (click)="submit()">
                <span *ngIf="!loadingState">
                    Share
                </span>
                <mat-progress-spinner *ngIf="loadingState" [diameter]="24"
                    [mode]="'indeterminate'"></mat-progress-spinner>
            </button>
        </div>
    </div>
    <div class="share-actions flex sm:flex-row sm:items-center justify-end px-6 border-t border-gray-200 h-20" *ngIf="activeTab === 'external'">
        <button class="share-cancel-btn border mr-2" [color]="'transparent'"
            mat-stroked-button
            (click)="cancel()">
            Cancel
        </button>
        <div class="flex items-center gap-2">
            <button
                class="share-submit-btn"
                mat-flat-button
                [color]="'primary'"
                [disabled]="isLoading || ngModelExt.length == 0 " (click)="submitExShare()">
                <span *ngIf="!externalLoading">
                    Share
                </span>
                <mat-progress-spinner *ngIf="externalLoading" [diameter]="24"
                    [mode]="'indeterminate'"></mat-progress-spinner>
            </button>
        </div>
    </div>
</div>